import { CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";
import styled from "styled-components";

type Props = {
	open: boolean;
	title: string;
	message: string;
};

const StyledDialogContent = styled(DialogContent)`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${props => props.theme.spacing(3)};
	padding: ${props => props.theme.spacing(4)};
	min-width: 400px;
`;

const StyledTitle = styled(Typography)`
	font-weight: ${props => props.theme.typography.fontWeightBold};
	text-align: center;
`;

const StyledMessage = styled(Typography)`
	text-align: center;
	color: ${props => props.theme.palette.text.secondary};
`;

export const DownloadProgressModal: React.FunctionComponent<Props> = props => {
	return (
		<Dialog
			open={props.open}
			disableEscapeKeyDown
			PaperProps={{
				sx: {
					borderRadius: 2,
				}
			}}
		>
			<StyledDialogContent>
				<CircularProgress size={60} thickness={4} />
				<StyledTitle variant="h6">
					{props.title}
				</StyledTitle>
				<StyledMessage variant="body2">
					{props.message}
				</StyledMessage>
			</StyledDialogContent>
		</Dialog>
	);
};
